/** WebSocket copilot — b2b_dev default when env var missing at build time. */
const B2B_DEV_COPILOT_WS_URL =
  "wss://sveb5q3mi9.execute-api.us-east-1.amazonaws.com/dev";

export function getCopilotWsUrl() {
  const fromEnv = (process.env.REACT_APP_COPILOT_WS_URL || "").trim();
  if (fromEnv) return fromEnv;
  if (process.env.NODE_ENV === "development") {
    return B2B_DEV_COPILOT_WS_URL;
  }
  // Production build sin REACT_APP_COPILOT_WS_URL (p. ej. Amplify pre-fix): fallback b2b_dev
  return B2B_DEV_COPILOT_WS_URL;
}
